import { motion } from "framer-motion";
import { Handshake, Building, Truck, ShoppingBag } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const cardReveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1, y: 0,
    transition: { delay: i * 0.12, duration: 0.5, ease: "easeOut" },
  }),
};

const partnerTypes = [
  { icon: Handshake, title: "Franchise", desc: "Join our network as a franchise partner and tap into the growing frozen beverage market." },
  { icon: Building, title: "Institutional", desc: "Enterprise-level partnerships for corporate cafeterias, hospitals, and educational institutions." },
  { icon: Truck, title: "Distribution", desc: "Become a distribution partner and help us expand our reach across India." },
  { icon: ShoppingBag, title: "Retail", desc: "Add our beverage systems to your retail location and boost your product offerings." },
];

export default function PartnerSection() {
  return (
    <section id="partner" data-testid="partner-section" className="py-16 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-80px" }}
          className="max-w-3xl mb-16"
        >
          <motion.p variants={fadeUp} className="text-[#C8D616] font-semibold text-sm uppercase tracking-widest mb-3">Partner With Us</motion.p>
          <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1D3A] leading-tight mb-6">Grow With Ultimate Infusions</motion.h2>
          <motion.p variants={fadeUp} className="text-base lg:text-lg text-slate-600 leading-relaxed">
            Whether you're a franchise operator, institutional buyer, distributor, or retailer &mdash; we have partnership models designed to maximise your returns.
          </motion.p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {partnerTypes.map((type, i) => (
            <motion.div
              key={type.title}
              variants={cardReveal}
              custom={i}
              className="p-6 lg:p-8 rounded-2xl border border-slate-100 bg-slate-50/50 hover:bg-white hover:shadow-lg hover:border-blue-100 transition-all duration-500 group"
            >
              <div className="w-12 h-12 rounded-lg bg-[#0B1D3A] flex items-center justify-center mb-5 group-hover:bg-[#C8D616] transition-colors duration-500">
                <type.icon size={22} className="text-white group-hover:text-[#0B1D3A] transition-colors duration-500" />
              </div>
              <h3 className="text-lg font-bold text-[#0B1D3A] mb-3">{type.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed">{type.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
